import { type MobileBottomNavItem } from '@cx-web/api-clients/nav-api/types';
import Icon from '@cx-web/components/primitives/icon';
import { trackingActions } from '@cx-web/feature-tracking';

import { mergePersistentParams } from '@cx-modules/utils';

import styles from '../../MobileBottomNav.module.css';
import { handleEvent } from '../../utils/handleEvent';

interface NavLinkProps {
  item: MobileBottomNavItem;
  pathname: string;
  serverUrl?: string;
}

export const NavLink = ({ item, pathname, serverUrl }: NavLinkProps) => {
  const [icon, dimension = '20'] = (item.icon || '').split(',');
  const isSelected = item.link === pathname;
  const requestUrl = typeof window !== 'undefined' ? window.location.href : serverUrl;

  return (
    <li
      aria-label={item.name}
      className={`${styles.menuItem} ${isSelected ? styles.active : ''}`}
      data-testid="mobile-bottom-nav-item"
      onClick={() => handleEvent(item.name, trackingActions)}
    >
      <a href={mergePersistentParams(item.link || '', requestUrl)}>
        {icon && (
          <span className={styles.iconContainer}>
            <Icon height={parseInt(dimension, 10)} icon={icon} width={parseInt(dimension, 10)} />
            {item.count ? <span className={styles.offerCount}>{item.count}</span> : null}
          </span>
        )}
        {item.name}
      </a>
    </li>
  );
};
